export class Ademas {
  idAdemas: number;
  tituloProyectoAdemas: string;
  descripcionAdemas: string;
  empresaAdemas: string;
  fechaAdemas: string;
  imagenAdemas: string;
  tituloDetalle: string;
  descripcionDetalle: string;
  imagenDetalle: string;
  imagenDetalle2: string;
  imagenDetalle3: string;
  imagenDetalle4: string;
  porcentajePhotoshop: string;
  porcentajeIllustrator: string;
  porcentajeMaya: string;
  porcentajeZbrush: string;
}
